import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import { push } from 'react-router-redux';

import Layout from '../layout';

import APP_ROUTES from '../../constants/app-routes';

import styles from '../styles/pages/signin.scss';
import SignInForm from '../shared/sign-in-form';
import UserUtils from '../../services/user-utils';
import spreeStore from '../../store';

class UserLogin extends Component {
    constructor(props) {
        super(props);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        document.title = this.props.intl.formatMessage({ id: 'signin', defaultMessage: 'Sign In' });
    }

    componentDidMount() {
        if (UserUtils.isLoggedIn()) {
            this.props.dispatch(push(APP_ROUTES.homePageRoute));
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.locale !== prevProps.locale) {
            document.title = this.props.intl.formatMessage({ id: 'signin', defaultMessage: 'Sign In' });
        }
    }

    handleFormSubmit(formData) {
        if (formData.user.password) {
            UserUtils.signUp(formData, this.props.locale.currentLocale).then(() => {
                spreeStore.dispatch(push(APP_ROUTES.homePageRoute));
            });
        } else {
            UserUtils.sendEmail(formData.user.email, this.props.locale.currentLocale);
        }
    }

    render() {
        return (
            <Layout>
                <main className={`content ${styles.signin}`}>
                    <div className={`container ${styles.bodyContainer}`}>
                        <section>
                            <p className={styles.titlePage}>
                                <FormattedMessage id="signin" defaultMessage="Sign In" />
                            </p>
                            <div className="row">
                                <div className="col-lg-offset-4 col-lg-4 col-md-4 col-md-offset-4 col-sm-offset-3 col-sm-6 col-xs-12">
                                    <SignInForm onSubmitCallback={(formData) => { this.handleFormSubmit(formData); }} />
                                </div>
                            </div>
                        </section>
                    </div>
                </main>
            </Layout>
        );
    }
}

export default injectIntl(UserLogin);



/** WEBPACK FOOTER **
 ** ./src/components/pages/user-login.jsx
 **/